import { useLayoutEffect, useRef, useState } from 'react';

const useElementHeight = () => {
    const elementRef = useRef(null);
    const [height, setHeight] = useState(0);

    useLayoutEffect(() => {
        const element = elementRef.current;
        if (!element) return undefined;

        const updateHeight = () => setHeight(Math.ceil(element.getBoundingClientRect().height));
        updateHeight();

        if (typeof ResizeObserver !== 'undefined') {
            const observer = new ResizeObserver(updateHeight);
            observer.observe(element);
            return () => observer.disconnect();
        }

        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    return { elementRef, height };
};

export default useElementHeight;
